import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f5e1ebea&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=f5e1ebea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e1ebea",
  null
  
)

export default component.exports